import { containerNotSupported, containerFrom, containerUpTo } from '../../styles/container';
import { makeStyles } from '../../styles/themes/themewrapper';

export const FLIGHT_SELECTOR_NAME = 'flightSelector';
export const FLIGHT_SELECTOR_SIZE = 720;
export const FLIGHT_SELECTOR_SIZE_LG = 820;

export const useCustomStyles = makeStyles<void, 'selected'>()((theme, _, classes) => ({
	flightSelector: {
		containerType: 'inline-size',
		containerName: FLIGHT_SELECTOR_NAME,
		backgroundColor: theme.flightSelection.background.color,
		borderRadius: theme.flightSelection.borderRadius,
		padding: `${theme.spacing.small} ${theme.spacing.medium}`,
		border: theme.flightSelection.border.default,
		margin: theme.border.thin,
		display: 'flex',
		flexDirection: 'column',
		position: 'relative',

		'&:hover': {
			cursor: 'pointer',
			border: theme.flightSelection.border.hover,
		},

		'&:has(:focus-visible)': {
			border: theme.flightSelection.border.focus,
			outline: 0,
			boxShadow: theme.flightSelection.focus,
		},

		[`&.${classes.selected}`]: {
			border: theme.flightSelection.border.selected,
			margin: 0,

			'&:hover': {
				border: theme.flightSelection.border.selected,
			},

			'&:has(:focus-visible)': {
				border: theme.flightSelection.border.selected,
			},
		},
	},

	flightSelectorContainer: {
		display: 'flex',
		gap: theme.spacing.small,
		flexDirection: 'column',

		[containerFrom(FLIGHT_SELECTOR_SIZE, FLIGHT_SELECTOR_NAME)]: {
			gap: theme.spacing.medium,
			flexDirection: 'row',
		},
	},

	flightsOverview: {
		flex: 1,
	},

	radioButtonContainer: {
		display: 'flex',
		gap: theme.spacing.small,

		[containerFrom(FLIGHT_SELECTOR_SIZE, FLIGHT_SELECTOR_NAME)]: {
			flexDirection: 'column',
			justifyContent: 'center',
		},
	},

	labelContainer: {
		[containerFrom(FLIGHT_SELECTOR_SIZE, FLIGHT_SELECTOR_NAME)]: {
			display: 'flex',
			flexDirection: 'column',
			justifyContent: 'space-between',
			width: 160,
			gap: theme.spacing.xxsmall,
		},

		[containerFrom(FLIGHT_SELECTOR_SIZE_LG, FLIGHT_SELECTOR_NAME)]: {
			width: 200,
		},
	},

	labels: {
		display: 'flex',
		gap: theme.spacing.tiny,
		flexWrap: 'wrap',
		justifyContent: 'flex-end',
		flexDirection: 'row',
	},
	tagContainer: {
		width: '100%',
	},

	inclusives: {
		[containerFrom(FLIGHT_SELECTOR_SIZE, FLIGHT_SELECTOR_NAME)]: {
			alignItems: 'flex-end',
		},
	},

	inclusive: {
		display: 'flex',
		alignItems: 'center',
		gap: theme.spacing.xxsmall,
	},

	isMobileOnly: {
		[containerFrom(FLIGHT_SELECTOR_SIZE, FLIGHT_SELECTOR_NAME)]: {
			display: 'none',
		},
	},

	isDesktopOnly: {
		[containerUpTo(FLIGHT_SELECTOR_SIZE, FLIGHT_SELECTOR_NAME)]: {
			display: 'none',
		},

		[containerNotSupported]: {
			display: 'none',
		},
	},

	selected: {},
}));
